<div class='container-fluid'>
  <div class="logo">
    <img src="assets/GLS_web_logo_withspace_1080x256.png" />
  </div>

  <div class='row'>
    <div class='col-sm-3'>
      <header>
        <nav>
          <app-nav-menu></app-nav-menu>
        </nav>
      </header>
    </div>
    <div class='col-sm-9 body-content'>
      <main>
        <router-outlet></router-outlet>
      </main>
      <aside>
        <alert></alert>
      </aside>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/app.component.html